export default __webpack_public_path__ + "static/measure-hero-reference-a383eff9853ba3f66b04d96ffbbe5b20.jpg";